import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
// import { AgGridReact } from 'ag-grid-react';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
// import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import AutosuggestComponent from '../../Utility/Components/AutosuggestComponent';
import { DebounceInput } from 'react-debounce-input';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import RefreshButton from '../../Utility/Components/RefreshButton';
import CustomNoRowsOverlay from '../../Utility/Components/CustomNoRowsOverlay';
import '../Assets/css/supportUserdoc.scss';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Utility from '../../Utility/Utility';
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import CommonDateTimePicker from '../../Utility/Components/CommonDateTimePicker';
import { auditHistoryList, supportUserList, hotelList, branchListApi } from '../Controller/SupportUserController';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ActionViewModalContent from './ActionViewModalContent';
import ModalGlobal from '../../Utility/Components/ModalGlobal';
import Select, { components as selectComponents, ValueContainerProps } from "react-select";

//multiselect support user select box customize container
const CustomValueContainer = ({ children, hasValue, getValue, ...props }) => {
    if (!hasValue) {
        return (
            <selectComponents.ValueContainer {...props}>
                {children}
            </selectComponents.ValueContainer>
        );
    }
    const CHIPS_LIMIT = 1;
    const [chips, otherChildren] = children;
    const overflowCounter = getValue().length;
    const displayChips = chips.slice(0, CHIPS_LIMIT);

    return (
        <selectComponents.ValueContainer {...props}>
            {displayChips}

            {overflowCounter > CHIPS_LIMIT && `+ ${overflowCounter - CHIPS_LIMIT} more`}

            {otherChildren}
        </selectComponents.ValueContainer>
    );
}

//multiselect support user select box customize menu option
const Menu = (props) => {
    return (
        <>
            <selectComponents.Menu {...props}>
                <div className="dropdowninnersection">
                    <div className="dropdownlabelbtn">
                        <div className="dropheaderlabel">{props.selectProps.menuHeader}</div>
                        <button className="dropheaderbtn" onClick={props.selectProps.oncloseMenu}>
                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} />
                        </button>
                    </div>
                    <div>{props.children}</div>
                </div>
            </selectComponents.Menu>
        </>
    );
};
function AuditHistoryModalContent(props) {
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const [isAnimating, setIsAnimating] = useState(true);
    var selectRefBookingStatus = null;
    const [isOpen, setIsOpen] = useState(false);
    //audit hisory aggrid column def
    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: 'Org Name',
                field: "org_name",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.BookingAuditHistoryHotel) {
                            let concatname = params.data.BookingAuditHistoryHotel.org_name
                            if (params.data.BookingAuditHistoryHotel.org_name && concatname.length > 0) {
                                return <div className="usercursor"><span className="textrenderview">
                                    <OverlayTrigger overlay={<Tooltip>{params.data && params.data.BookingAuditHistoryHotel.org_name != "" ? (params.data.BookingAuditHistoryHotel.org_name).charAt(0).toUpperCase()
                                        + (params.data.BookingAuditHistoryHotel.org_name).slice(1) : ""}</Tooltip>}>
                                        <span >
                                            {params.data && params.data.BookingAuditHistoryHotel && params.data.BookingAuditHistoryHotel.org_name != "" ? (params.data.BookingAuditHistoryHotel.org_name).charAt(0).toUpperCase() + (params.data.BookingAuditHistoryHotel.org_name).slice(1) : ""}
                                        </span>
                                    </OverlayTrigger>
                                </span></div>
                            } else {
                                return (<div className="usercursor"><span className="textrenderview">{params.data && params.data.BookingAuditHistoryHotel.org_name != "" ? (params.data.BookingAuditHistoryHotel.org_name).charAt(0).toUpperCase()
                                    + (params.data.BookingAuditHistoryHotel.org_name).slice(1) : ""}</span></div>)
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Branch Name',
                field: "branch_name",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.BookingAuditHistoryBranch) {
                            let concatname = params.data.BookingAuditHistoryBranch.branch_name
                            if (params.data.BookingAuditHistoryBranch.branch_name && concatname.length > 0) {
                                return <div className="usercursor"><span className="textrenderview">
                                    <OverlayTrigger overlay={<Tooltip>{params.data && params.data.BookingAuditHistoryBranch.branch_name != "" ? (params.data.BookingAuditHistoryBranch.branch_name).charAt(0).toUpperCase()
                                        + (params.data.BookingAuditHistoryBranch.branch_name).slice(1) : ""}</Tooltip>}>
                                        <span >
                                            {params.data && params.data.BookingAuditHistoryBranch && params.data.BookingAuditHistoryBranch.branch_name != "" ? (params.data.BookingAuditHistoryBranch.branch_name).charAt(0).toUpperCase() + (params.data.BookingAuditHistoryBranch.branch_name).slice(1) : ""}
                                        </span>
                                    </OverlayTrigger>
                                </span></div>
                            } else {
                                return (<div className="usercursor"><span className="textrenderview">{params.data && params.data.BookingAuditHistoryBranch.branch_name != "" ? (params.data.BookingAuditHistoryBranch.branch_name).charAt(0).toUpperCase()
                                    + (params.data.BookingAuditHistoryBranch.branch_name).slice(1) : ""}</span></div>)
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Name',
                field: "name",
                minWidth: 200,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data && params.data.hasOwnProperty('BookingAuditHistoryCreatedBy') && params.data.BookingAuditHistoryCreatedBy != null) {
                        let concatname = params.data.BookingAuditHistoryCreatedBy?.first_name + "" + params.data.BookingAuditHistoryCreatedBy?.last_name
                        if (params.data.BookingAuditHistoryCreatedBy.first_name && params.data.BookingAuditHistoryCreatedBy.first_name && concatname.length > 15) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data && params.data.BookingAuditHistoryCreatedBy.first_name != "" ? Utility.displayNameFormat(params.data.BookingAuditHistoryCreatedBy.first_name, params.data.BookingAuditHistoryCreatedBy.last_name) : ""}</Tooltip>}>
                                    <span >
                                        {params.data && params.data.BookingAuditHistoryCreatedBy.first_name != "" ? Utility.displayNameFormat(params.data.BookingAuditHistoryCreatedBy.first_name, params.data.BookingAuditHistoryCreatedBy.last_name) : ""}
                                    </span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return (<div><span className="textrenderview">{params.data.BookingAuditHistoryCreatedBy && params.data.BookingAuditHistoryCreatedBy.first_name != "" ? Utility.displayNameFormat(params.data.BookingAuditHistoryCreatedBy.first_name, params.data.BookingAuditHistoryCreatedBy.last_name) : ""}</span></div>)
                        }

                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Date',
                field: "createdAt",
                minWidth: 150,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.createdAt) {
                            return <div><span >{moment(params.data.createdAt).format('DD-MM-YYYY HH:mm')}</span></div>
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Action Taken',
                field: "status",
                minWidth: 400,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.audit_type.length >= 38) {
                            return <div className="infoviewbox" onClick={(e) => actionDetailsModal(params)}>
                                <div className="infoviewlabel">{(params.data.audit_type).substring(0, 35) + "..."}</div>
                                <div className="infoviewicon hotel_branch_btn"><OverlayTrigger overlay={<Tooltip>Click to view details</Tooltip>}><i className="fa fa-info-circle"></i></OverlayTrigger>
                                </div>
                            </div>
                        } else {
                            return <div className="infoviewbox" onClick={(e) => actionDetailsModal(params)}>
                                <div className="infoviewlabel">{params.data.audit_type}</div>
                                {params.data.audit_type.length == 0 ? <></> : <div className="infoviewicon hotel_branch_btn"><OverlayTrigger overlay={<Tooltip>Click to view details</Tooltip>}><i className="fa fa-info-circle"></i></OverlayTrigger>
                                </div>}
                            </div>
                        }
                    } else {
                        return null;
                    }
                },
            }

        ]
    )
    const gridRef = useRef();

    const [supportUserData, setSupportUserData] = useState([]);
    const [selectedSupportUser, setSelectedSupportUser] = useState([]);
    const [reportStartDate, setReportStartDate] = useState('');
    const [reportEndDate, setReportEndDate] = useState('');
    const [actionDetails, setActionDetails] = useState('');
    const [actionDetailsModalflag, setActionDetailsModalflag] = useState(false);
    const [isFirstApiCall, setIsFirstApiCall] = useState(true);
    const userTypeRef = useRef(true);

    const [organisationData, setOrganisationData] = useState([]);
    const [selectedOrganisation, setSelectedOrganisation] = useState('');
    const [branchData, setBranchData] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');

    //support user multi select menu close fn
    const onCloseMenuBookingStatus = () => {
        selectRefBookingStatus.blur()
    };
    const dropdownRef = useRef(null);

    //outside clck menu close event
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutsideStatus);
        return () => {
            document.removeEventListener("mousedown", handleClickOutsideStatus);
        };
    }, []);

    const handleClickOutsideStatus = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    //action details view modal open fn
    const actionDetailsModal = (obj) => {
        let auditData = obj?.data?.audit_type;
        setActionDetails(auditData)
        setActionDetailsModalflag(true)
    }

    //close action details view fn
    const closeActionDetailsModalFn = () => {
        setActionDetailsModalflag(false);
        setActionDetails('');
    }

    //audit history aggrid ongridready fn
    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    //reset aggrid data fn
    const resetDataGrid = () => {
        var datasource = serverSideDataSource()
        gridApi.setDatasource(datasource);
    }
    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    //aggid serverside api fn
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                setIsAnimating(true);
                let filters = formattingAuditDataSetFn(startRow, sortModel, false);
                setIsFirstApiCall(false);
                if (props.supportUserId.length > 0 && isFirstApiCall) { } else {
                    auditHistoryList(filters).then((response) => {
                        if (response.success) {
                            if (response.data.length == 0 && startRow == 0) {
                                gridRef.current.api.showNoRowsOverlay();
                            } else {
                                gridRef.current.api.hideOverlay();
                            }
                            params.successCallback(response.data, response.total);
                            setIsAnimating(false);
                        } else {
                            console.error(error);
                            params.failCallback();
                            Utility.toastNotifications("Something went wrong !", "Error", "error")
                            setIsAnimating(false);
                        }

                    }).catch((error) => {
                        console.error("************error*************", error)
                        if (error) {
                        }
                        loaderStateFalse();
                        setIsAnimating(false);
                        if (error.message == "Network Error") {

                        }
                    });
                }
            }
        };
    }

    //audit history get api dataset formatting fn
    const formattingAuditDataSetFn = (startRow, sortModel = [], csvDownload = false) => {
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};
        if (!csvDownload) {
            globalQueryParamshash["offset"] = startRow;
            globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);
        }
        if (reportStartDate && reportStartDate != "" && reportEndDate && reportEndDate != "") {
            let from_date = moment(new Date(reportStartDate)).format('YYYY-MM-DD')
            let to_date = moment(new Date(reportEndDate)).format('YYYY-MM-DD')
            globalQueryParamshash['date'] = [from_date, to_date];
            filter_op = Object.assign(filter_op, { "date": "between" });
        }
        if (selectedBranch != "") {
            globalQueryParamshash['branch_id'] = selectedBranch['value'];
        }
        if (selectedOrganisation != "") {
            globalQueryParamshash['org_id'] = selectedOrganisation['value'];
        }
        if (selectedSupportUser.length > 0) {
            globalQueryParamshash['created_by'] = selectedSupportUser.map(user => user.value);
        }
        if (sortModel.length > 0) {
            const statusSortExists = sortModel.some(item => item.sort === "desc" || "asc" && item.colId === "createdAt");
            if (!statusSortExists) {
                sortModel.push({ "sort": "desc", "colId": "createdAt" });
            }
            globalQueryParamshash['sort'] = sortModel;
        } else {
            globalQueryParamshash['sort'] = [{ "sort": "desc", "colId": "createdAt" }];
        }
        if (csvDownload) {
            globalQueryParamshash["type"] = 'csv';
        }

        if (Object.keys(filter_op).length > 0) {
            filters["filter_op"] = JSON.stringify(filter_op);
        }
        filters['filters'] = JSON.stringify(globalQueryParamshash)
        return filters;
    }

    //aggrid grid option define
    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,
        }),
        []
    )

    //initially hotel list api fetch call for hotel filteraion
    useEffect(() => {
        if (userTypeRef.current) {
            userTypeRef.current = false;
            getHotelListApi();
        }
    }, [])

    //hotel list api call
    const getHotelListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        loaderStateTrue();
        setOrganisationData([]);
        setBranchData([]);
        let hotelListArray = []
        let filter = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["sort_by_name"] = true;
        globalQueryParamshash["is_active"] = true;
        filter['filters'] = JSON.stringify(globalQueryParamshash);
        hotelList(filter).then((response) => {
            response.data.map((e) => {
                let HotelListObj = {};
                HotelListObj['label'] = `${e.org_name}`;
                HotelListObj['value'] = e.id;
                hotelListArray.push(HotelListObj);
            })
            setOrganisationData(hotelListArray);
            getAllSupportUserDataFn();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    //hotel branch list api call for branch related filter
    const getHotelBranchListApi = (data) => {
        return new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            loaderStateTrue();
            let filters = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["org_id"] = data.value;
            filters['filters'] = JSON.stringify(globalQueryParamshash);
            // Calling the API
            branchListApi(filters, 'v4')
                .then((response) => {
                    let hotelBranchResponse = Object.keys(response.data).length > 0
                        && response.data[Object.keys(response.data)[0]]?.HotelBranchHotelRelation.length > 0
                        ? response.data[Object.keys(response.data)[0]].HotelBranchHotelRelation
                        : {};

                    let branchList = [];
                    let branchListObj = {};

                    hotelBranchResponse.map((e) => {
                        branchListObj = {};
                        branchListObj['label'] = `${e.branch_name}`;
                        branchListObj['value'] = e.id;
                        branchList.push(branchListObj);
                    });

                    if (branchList.length > 0) {
                        setBranchData(branchList);
                    }

                    resolve(branchList);
                })
                .catch((error) => {
                    reject(error); // Properly reject in case of error
                })
                .finally(() => {
                    loaderStateFalse(); // Ensure the loader is turned off
                });
        });
    };


    //support user list get api fn
    const getAllSupportUserDataFn = () => {
        const { loaderStateFalse, loaderStateTrue } = props;
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["user_type"] = "support_user";
        filters['filters'] = JSON.stringify(globalQueryParamshash)
        supportUserList(filters).then((response) => {
            if (response.success) {
                if (response.data && response.data.length > 0) {
                    let userData = [];
                    response.data.forEach((item) => {
                        let userDataObj = {};
                        userDataObj['label'] = Utility.displayNameFormat(item.first_name, item.last_name);
                        userDataObj['value'] = item.id;
                        userData.push(userDataObj);
                    });
                    setSupportUserData(userData);
                }

            } else {
                console.error(error);
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            loaderStateFalse();
            if (error) {
            }
        });
    }

    //select the support user on suppoer user dropdown filteration
    useEffect(() => {
        if (supportUserData.length > 0 && props.supportUserId.length > 0) {
            let userFilterSelectedValue = [];
            props.supportUserId.forEach((id) => {
                const matchedUser = supportUserData.find((user) => user.value === id);
                if (matchedUser) {
                    userFilterSelectedValue.push(matchedUser);
                }
            });
            setSelectedSupportUser(userFilterSelectedValue);
        }
    }, [supportUserData])


    //filter panel dropdown onchange fn 
    const handleChangeUserFilter = async (type, e) => {
        if (type == "support_user") {
            if (e) {
                setSelectedSupportUser(e);
            } else {
                setSelectedSupportUser([])
            }
        }
        if (type == "organisation") {
            if (e) {
                setSelectedOrganisation(e);
                let hotelWiseBranchData = await getHotelBranchListApi(e);
                setBranchData(hotelWiseBranchData)
            } else {
                setSelectedBranch('')
                setSelectedOrganisation('');
                setBranchData([]);
            }
        }

        if (type == "branch") {
            if (e) {
                setSelectedBranch(e);
            } else {
                setSelectedBranch('')
            }
        }
    };

    //change support user , reset the grid
    useEffect(() => {
        if (gridApi && selectedSupportUser.length > 0) {
            resetDataGrid();
        }
        if (gridApi && selectedSupportUser.length == 0) {
            resetDataGrid();
        }
    }, [selectedSupportUser])

    //change hotel selection , reset the grid
    useEffect(() => {
        if (gridApi && Object.keys(selectedOrganisation).length > 0) {
            resetDataGrid();
        }
        if (gridApi && selectedOrganisation.length == 0) {
            resetDataGrid();
        }
    }, [selectedOrganisation])

    //change branch selection , reset the grid
    useEffect(() => {
        if (gridApi && Object.keys(selectedBranch).length > 0) {
            resetDataGrid();
        }
        if (gridApi && selectedBranch.length == 0) {
            resetDataGrid();
        }
    }, [selectedBranch])

    //date range filter onchange fn
    const onChangeDateRange = (dates, blur = false) => {
        const [start, end] = dates;
        if (!blur && end && start.getTime() === end.getTime()) {
            return;
        }
        setReportStartDate(start);
        setReportEndDate(end);
    };

    // change date range reset audit history grid
    useEffect(() => {
        if (gridApi && reportStartDate && reportStartDate != "" && reportEndDate && reportEndDate != "") {
            resetDataGrid();
        } else if (gridApi && reportStartDate == null && reportEndDate == null) {
            resetDataGrid();
        }
    }, [reportEndDate])

    //audit history reload button fn
    const loadGrid = () => {
        resetDataGrid();
    }

    //audit history csv create fn
    const auditDetailsCsvFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let filter = formattingAuditDataSetFn(0, [], true);
        loaderStateTrue();
        auditHistoryList(filter).then((response) => {
            if (response.hasOwnProperty('success') && !response.success) {
                Utility.toastNotifications(response.message, 'Warning', 'warning')
            } else {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `audit_history_${moment().format("DD_MM_YYYY_hh_mm")}.csv`);
                link.click();
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
        });
    }

    return (
        <div className="gridcontainer supportUserContainer auditHistorygridcontainer">
            <div className="totalworkercontent">
                <div className='filterSection'>
                    <div className="gridtopviews gridtopviewsHistory">
                        <div className="dropdownbox statusdropcontainer dropWithCount">
                            <AutosuggestComponent
                                handleOnChange={(e) => { handleChangeUserFilter('organisation', e) }}
                                options={organisationData}
                                selectedValue={selectedOrganisation}
                                name=''
                                isMulti={false}
                                placeholder="Hotel"
                                isDisabled={false}
                                isClearable={selectedOrganisation.length == 0 ? false : true}
                                closeButton={false}
                                menuHeader="Hotel"
                                isSearchable={true}
                                openMenu={true}
                            />
                        </div>
                        <div className="dropdownbox statusdropcontainer dropWithCount">
                            <AutosuggestComponent
                                handleOnChange={(e) => { handleChangeUserFilter('branch', e) }}
                                options={branchData}
                                selectedValue={selectedBranch}
                                name=''
                                isMulti={false}
                                placeholder="Branch"
                                isDisabled={branchData.length > 0 ? false : true}
                                isClearable={selectedBranch.length == 0 ? false : true}
                                closeButton={false}
                                menuHeader="Branch"
                                isSearchable={true}
                                openMenu={true}
                            />
                        </div>
                        <div className="dropdownbox statusdropcontainer bookingstatusdropcontainer dropWithCount" ref={dropdownRef}>
                            <Select
                                options={supportUserData}
                                value={selectedSupportUser}
                                onChange={(e) => { handleChangeUserFilter('support_user', e) }}
                                isMulti={true}
                                components={{
                                    ValueContainer: CustomValueContainer,
                                    Menu
                                }}
                                isClearable={true}
                                closeMenuOnSelect={false}
                                openMenuOnFocus={true}
                                placeholder="Support User"
                                menuHeader="Support User"
                                oncloseMenu={(e) => onCloseMenuBookingStatus()}
                                ref={(scope) => { selectRefBookingStatus = scope }}
                                isDisabled={false}
                                isSearchable={true}
                                // menuPosition="fixed"
                                hideSelectedOptions={false}
                                classNamePrefix="status-dropdown-default common-dropdown-box"
                                menuIsOpen={isOpen}
                                onMenuOpen={() => setIsOpen(true)}
                                onMenuClose={() => setIsOpen(false)}
                            />
                        </div>
                        <form>
                            <div className="rightboxes rightboxesquationbox">
                                <div className='date-range-picker right-side-space quationRange'>
                                    <ErrorBoundary title="CommonDateTimePicker Error">
                                        <CommonDateTimePicker
                                            dateRange={true}
                                            selected={reportStartDate}
                                            onChange={onChangeDateRange}
                                            startDate={reportStartDate}
                                            endDate={reportEndDate}
                                            selectsRange={true}
                                            isClearable={reportStartDate != "" && reportEndDate != "" ? true : false}
                                            placeholderText="Select Date Range"
                                            minDate=""
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className='downloadCsvBtn'>
                                    <OverlayTrigger overlay={<Tooltip>{"Download CSV"}</Tooltip>}>
                                        <div onClick={() => { auditDetailsCsvFn() }} className='csvBtnInner'><i className="fa fa-download" aria-hidden="true"></i>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='grid_content_inner'>
                    <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative', height: "500px" }}>
                        <div className="leadButtonInner"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                            isAnimating={isAnimating}
                        />
                        </button>
                            <ReactTooltip place="bottom" />
                        </div>
                        <AgGridReact
                            modules={modules}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            components={components}
                            rowSelection="single"
                            rowModelType="infinite"
                            onGridReady={onGridReady}
                            rowHeight={43.9}
                            headerHeight={40.8}
                            cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                            gridOptions={gridOptions}
                            noRowsOverlayComponent={noRowsOverlayComponent}
                            ref={gridRef}
                        />
                    </div>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={actionDetailsModalflag}
                    onHide={closeActionDetailsModalFn}
                    title={'Audit Action'}
                    className="modalcustomize mondimension refundDetailsModalContent convertBookingModalDialog"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="BookRoomModalContent Error">
                                <ActionViewModalContent
                                    actionText={actionDetails}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div>
    )
}

AuditHistoryModalContent.defaultProps = {
    supportUserId: []
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withTranslation()(AuditHistoryModalContent));